/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Open360BusinessLogicRetailersMeasurementsBEMeasurementsFilter {
    /**
     * 1 = Male, 2 = Female
     */
    Gender?: Open360BusinessLogicRetailersMeasurementsBEMeasurementsFilter.GenderEnum;
}
export namespace Open360BusinessLogicRetailersMeasurementsBEMeasurementsFilter {
    export type GenderEnum = 1 | 2;
    export const GenderEnum = {
        NUMBER_1: 1 as GenderEnum,
        NUMBER_2: 2 as GenderEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360BusinessLogicRetailersMeasurementsBEMeasurementsFilter.ts